import { render } from "./CosmoSetup.vue?vue&type=template&id=5154d6bc&scoped=true"
import script from "./CosmoSetup.vue?vue&type=script&lang=js"
export * from "./CosmoSetup.vue?vue&type=script&lang=js"

import "./CosmoSetup.vue?vue&type=style&index=0&id=5154d6bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5154d6bc"]])

export default __exports__